const queueKey = (userId) => `lex_word_save_queue_${userId}`;

export function enqueueWordSave(userId, entry) {
    if (!userId || !entry?.wordId || !entry?.newStatus) return;
    try {
        const raw = localStorage.getItem(queueKey(userId));
        const list = raw ? JSON.parse(raw) : [];
        const next = Array.isArray(list) ? list : [];
        const idx = next.findIndex((i) => i.wordId === entry.wordId);
        const row = {
            wordId: entry.wordId,
            newStatus: entry.newStatus,
            word: entry.word || null,
            mode: entry.mode || null,
            fromStatus: entry.fromStatus || null,
            ts: Date.now(),
            retryCount: entry.retryCount || 0,
        };
        if (idx >= 0) next[idx] = row;
        else next.push(row);
        localStorage.setItem(queueKey(userId), JSON.stringify(next));
    } catch (e) {
        console.warn('[wordSaveQueue] enqueue failed:', e?.message || e);
    }
}

export function peekWordSaveQueue(userId) {
    try {
        const raw = localStorage.getItem(queueKey(userId));
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
    } catch {
        return [];
    }
}

export function removeWordSave(userId, wordId) {
    try {
        const list = peekWordSaveQueue(userId).filter((i) => i.wordId !== wordId);
        if (list.length === 0) {
            localStorage.removeItem(queueKey(userId));
        } else {
            localStorage.setItem(queueKey(userId), JSON.stringify(list));
        }
    } catch (e) {
        console.warn('[wordSaveQueue] remove failed:', e?.message || e);
    }
}

export function clearWordSaveQueue(userId) {
    try {
        localStorage.removeItem(queueKey(userId));
    } catch (_) { /* ignore */ }
}
